import React, { useEffect, useState } from "react";
import axios from "axios";
import { getCurrentDate } from "../../Utilitie";
import toast from "react-hot-toast";
import NoDataFound from "../../Extra/NoDataFound";

const CrewUpdate = () => {
  const [rawdata, setRawdata] = useState([]);
  const [entry, setEntry] = useState([]);
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [result, setResult] = useState(false);
  const [show, setShow] = useState(false);
  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [startDate, setStartDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [endDate, setEndDate] = useState(new Date().toISOString().slice(0, 10));

  const keys = [
    "ID",
    "CR_DATE",
    "CR_DEMANDED",
    "CR_GIVEN",
    "CR_UTILIZED",
    "CR_WASTED",
    "LOCO_DEMANDED",
    "LOCO_GIVEN",
    "LOCO_WASTED",
    "REMARKS",
    "updated_by",
  ];

  const fetchData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlBlockPrefix}getcrewDemanded?start=${startDate}&end=${endDate}`
      );
      // console.log(response.data);
      if (response.data.status === "ok") {
        const dataWithDefaults = response.data.daterange.data.map((item) => ({
          ...item,
          updated_by: item.updated_by,
        }));

        setRawdata(dataWithDefaults);
        setEntry(dataWithDefaults);
      } else {
        setRawdata([]);
        setEntry([]);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setError(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);
  // console.log(rawdata);

  useEffect(() => {
    const updatedData = entry.map((item) =>
      keys.reduce((acc, key) => {
        if (key === "updated_by") {
          acc[key] = item[key] || 3;
        } else {
          acc[key] = item[key] || "";
        }
        return acc;
      }, {})
    );
    setAllData(updatedData);
  }, [entry]);

  const handleChange = (rowIndex, key, value) => {
    const updatedEntries = [...entry];
    updatedEntries[rowIndex] = {
      ...updatedEntries[rowIndex],
      [key]: value,
    };
    setEntry(updatedEntries);
  };

  const handleSubmit = async () => {
    const finalData = allData.map((entry) => {
      const isoDate = new Date(entry.CR_DATE).toISOString().slice(0, 10);
      return {
        ...entry,
        CR_DATE: isoDate,
        updated_by: entry.updated_by,
        id: entry.id,
      };
    });

    try {
      const response = await axios.put(
        `${urlBlockPrefix}updateCrewDemanded`,
        finalData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      alert("Data updated successfully!");
    } catch (err) {
      console.error("Update error:", err.response?.data || err);
      alert("Update failed.");
    }
  };

  const handleDelete = async (rowId) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this entry?"
    );
    if (!confirmed) return;

    setLoading(true);
    let result = {};

    try {
      const response = await fetch(
        `${urlBlockPrefix}deleteCrewDemanded/${rowId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      result = await response.json();
      // console.log(result);
      if (result.message === "CREW Demanded Data deleted successfully") {
        toast.success(result.message);
        setShow(true);
        fetchData();
      } else if (result.status === "Warning") {
        setResult({ status: "Warning", message: result.message });
        setShow(true);
      }

      setLoading(false);
    } catch (err) {
      console.error("Error submitting data:", err);
      setResult({ status: "error", message: result?.message || err.message });
      setShow(true);
      setLoading(false);
    }
  };

  return (
    <div className=" papaDiv">
      <h5 className="mb-3 bg-dark text-white p-1 text-center fw-bold">
        Update Crew Demand Data
      </h5>
      <div className="d-flex justify-content-center gap-3 mb-4 align-items-center bg-dark ">
        <label className="m-4 text-white fw-bolder">
          Start Date:{" "}
          <input
            type="date"
            max={endDate}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </label>
        <label className="m-4  text-white fw-bolder">
          End Date:{" "}
          <input
            type="date"
            min={startDate}
            value={endDate}
            max={getCurrentDate()}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </label>
        <button onClick={fetchData}>Fetch</button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-danger">Error loading data</p>
      ) : (
        <div>
          <div className="table-responsive">
            {!entry ? null : entry.length === 0 ? (
              <div className="text-center mt-4">
                <h5 className="text-muted">
                  Please select a date to load data.
                </h5>
                <NoDataFound />
              </div>
            ) : (
              <table className="table table-bordered table-striped mb-4">
                <thead className="table-dark text-center align-middle">
                  <tr>
                    {keys.map(
                      (key, i) =>
                        key !== "updated_by" && (
                          <th key={i} style={{ minWidth: "90px" }}>
                            {key.toUpperCase().replace(/_/g, " ")}
                          </th>
                        )
                    )}
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {entry.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {keys.map(
                        (key, colIndex) =>
                          key !== "updated_by" && (
                            <td key={colIndex}>
                              {key === "CR_DATE" ? (
                                <input
                                  type="date"
                                  className="form-control"
                                  style={{ fontSize: "0.8rem" }}
                                  value={
                                    row[key]
                                      ? row[key].slice(0, 10)
                                      : new Date().toISOString().slice(0, 10)
                                  }
                                  onChange={(e) =>
                                    handleChange(rowIndex, key, e.target.value)
                                  }
                                />
                              ) : key === "REMARKS" ? (
                                <input
                                  type="text"
                                  className="form-control"
                                  style={{ width: "160px", fontSize: "0.8rem" }}
                                  value={row[key] || ""}
                                  onChange={(e) =>
                                    handleChange(rowIndex, key, e.target.value)
                                  }
                                />
                              ) : key === "id" ? (
                                <div>{row[key]}</div>
                              ) : (
                                <input
                                  type="number"
                                  className="form-control"
                                  style={{
                                    height: "26px",
                                    padding: "2px 6px",
                                    fontSize: "0.8rem",
                                  }}
                                  value={row[key] || ""}
                                  onChange={(e) =>
                                    handleChange(rowIndex, key, e.target.value)
                                  }
                                />
                              )}
                            </td>
                          )
                      )}
                      <td>
                        {" "}
                        <td>
                          <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => handleDelete(row.ID)}
                          >
                            Delete
                          </button>
                        </td>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          <div className="text-center mt-4">
            <button
              className="btn btn-outline-success m-2 px-5"
              onClick={handleSubmit}
            >
              Update
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CrewUpdate;
